module.exports = __webpack_public_path__ + "img/744.3971edc0.jpg";